import React from "react";
import { AcceptanceListProps } from "./type";
import { useLazyLoad } from "../../helpers/hooks";
const Comp = React.lazy(() => import("./AcceptanceList"));

export default (props: AcceptanceListProps) => useLazyLoad(<Comp {...props} />);
